import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { GlobalSearchResponse, HttpResponse } from "@/types";

// TODO: Potentially use the name `GlobalCommandPaletteSearch` instead so that `GlobalCommandPaletteAction` can be used in the future.
export const useGlobalSearch = (globalSearchQuery: string) => {
  return useQuery({
    enabled: !!globalSearchQuery.trim(),
    queryKey: ["global-search", globalSearchQuery],
    queryFn: async () => {
      const path = `global-search?query=${globalSearchQuery}`;

      const res = await guacHttpClient.get<
        GlobalSearchResponse,
        HttpResponse<GlobalSearchResponse>
      >(path);

      return res.data;
    },
  });
};
